import { differenceInMonths } from 'date-fns'
import { Vue } from 'vue-property-decorator'

export default async function onInputCheckingAccounts(
	trial,
	name,
	value,
	that,
	updateKeys,
	updateList,
) {
	let localUpdateList
	if (updateList && updateList.length) {
		localUpdateList = [...updateList]
	}

	const checkingAccount = that.getCheckingAccounts(trial)
	const alreadyUpdated: any = []

	if (typeof value === 'string') {
		if (/^[0-9]+$/.test(value)) {
			value = parseInt(value, 10)
		}
	}

	if (typeof value === 'string') {
		if (/^[0-9]+\.?[0-9]+$/.test(value)) {
			value = parseFloat(value)
		}
	}

	Vue.set(checkingAccount, name, value)

	if (localUpdateList && localUpdateList.length) {
		alreadyUpdated.push(name)
		localUpdateList.unshift(name)
	}

	const checkingAccountId = checkingAccount?.id
	if (!that.statusReference[checkingAccountId]) {
		Vue.set(that.statusReference, checkingAccountId, {})
	}
	Vue.set(that.statusReference[checkingAccountId], name, 'loading')

	if (localUpdateList && localUpdateList.length) {
		localUpdateList.forEach((fieldName) => {
			switch (fieldName) {
				case 'preDistributionCredit':
					setField(
						'feeAmount',
						checkingAccount,
						calculateFeeAmount(
							checkingAccount.preDistributionCredit,
							checkingAccount.feePercentage,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionMonthlyCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit /
							checkingAccount.calculationMonths,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDecisionAmount',
						checkingAccount,
						calculatePostDecisionAmount(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.extraMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'totalBalance',
						checkingAccount,
						calculateTotalBalance(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.postFavorableDecisionMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'feePercentage':
					setField(
						'feeAmount',
						checkingAccount,
						calculateFeeAmount(
							checkingAccount.preDistributionCredit,
							checkingAccount.feePercentage,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'decisionDate':
					setField(
						'extraMonths',
						checkingAccount,
						differenceInMonths(
							new Date(checkingAccount.decisionDate),
							new Date(trial.distributionDate),
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postFavorableDecisionMonths',
						checkingAccount,
						differenceInMonths(
							new Date(checkingAccount.decisionDate),
							new Date(),
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDecisionAmount',
						checkingAccount,
						calculatePostDecisionAmount(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.extraMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'totalBalance',
						checkingAccount,
						calculateTotalBalance(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.postFavorableDecisionMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'calculationMonths':
					setField(
						'postDistributionMonthlyCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit /
							checkingAccount.calculationMonths,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDecisionAmount',
						checkingAccount,
						calculatePostDecisionAmount(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.extraMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'totalBalance',
						checkingAccount,
						calculateTotalBalance(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.postFavorableDecisionMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'extraMonths':
					setField(
						'postDecisionAmount',
						checkingAccount,
						calculatePostDecisionAmount(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.extraMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'postFavorableDecisionMonths':
					setField(
						'totalBalance',
						checkingAccount,
						calculateTotalBalance(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.postFavorableDecisionMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'postDistributionMonthlyCredit':
					setField(
						'postDecisionAmount',
						checkingAccount,
						calculatePostDecisionAmount(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.extraMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					setField(
						'totalBalance',
						checkingAccount,
						calculateTotalBalance(
							checkingAccount.postDistributionMonthlyCredit,
							checkingAccount.postFavorableDecisionMonths,
						),
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'postDecisionAmount':
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					break
				case 'postDistributionTotalCredit':
					setField(
						'postDistributionTotalCredit',
						checkingAccount,
						checkingAccount.preDistributionCredit +
							checkingAccount.postDecisionAmount,
						alreadyUpdated,
						updateKeys,
					)
					break
			}

			if (fieldName !== name) {
				Vue.set(
					that.statusReference[checkingAccountId],
					fieldName,
					'warning',
				)
			}
		})
	}

	const saveObj = {}

	if (alreadyUpdated && alreadyUpdated.length) {
		alreadyUpdated.forEach((fieldName) => {
			saveObj[fieldName] = checkingAccount[fieldName]
		})
	}

	saveObj[name] = checkingAccount[name]

	const result = await that.save(checkingAccountId, saveObj)
	if (result.ok) {
		Vue.set(that.statusReference[checkingAccountId], name, 'success')
	} else {
		Vue.set(that.statusReference[checkingAccountId], name, 'error')
	}
}

function setField(name, checkingAccount, result, alreadyUpdated, updateKeys) {
	Vue.set(checkingAccount, name, result)
	alreadyUpdated.push(name)
	updateKeys[name]++
}

function calculateFeeAmount(preDistributionCredit, feePercentage) {
	return preDistributionCredit * feePercentage
}

function calculatePostDecisionAmount(
	postDistributionMonthlyCredit,
	extraMonths,
) {
	return postDistributionMonthlyCredit * extraMonths
}

function calculateTotalBalance(
	postDistributionMonthlyCredit,
	postFavorableDecisionMonths,
) {
	return postDistributionMonthlyCredit * postFavorableDecisionMonths
}
